module.exports = __webpack_public_path__ + "static/teacher-eb8cd19ef0a9a5f76bb2d795deaa8de4.svg";